import { ShieldCheck, Radio, FileArchive, UserCheck } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Product Context Library",
    description:
      "Load your product detail once.",
  },
  {
    icon: Radio,
    title: "Proactive Regulatory Monitoring",
    description:
      "When TGA, AHPRA, FSANZ or ACCC updates guidance, CompliGUARD automatically re-scans your product profiles. You act on regulatory change before it becomes a liability.",
  },
  {
    icon: FileArchive,
    title: "Audit Vault",
    description:
      "Every review decision is timestamped and stored. If the regulators come calling, your evidence of due diligence is already documented.",
  },
  {
    icon: UserCheck,
    title: "Human Escalation if required",
    description:
      "When AI confidence drops below threshold, a qualified compliance specialist reviews the decision. You get certainty, not a guess.",
  },
];

const Solution = () => {
  return (
    <section className="py-16 sm:py-28 bg-secondary">
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
        <p className="section-label mb-4 text-left">THE COMPLIGUARD DIFFERENCE</p>
        <div className="teal-rule mb-6 sm:mb-8" />

        <h2 className="text-2xl sm:text-4xl font-bold text-foreground mb-4 text-left max-w-3xl">
          CompliGUARD is the digital compliance layer your brand has been missing.
        </h2>

        <div className="text-text-body text-base sm:text-lg mb-10 sm:mb-16 text-left max-w-3xl leading-relaxed space-y-4">
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Load your product context once — ARTG data and permitted claims for listed medicines, or FSANZ health claim substantiation for functional foods and nutraceuticals</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Review any marketing content instantly</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Generate a compliant rewrite in seconds</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Store every decision in a tamper-evident audit vault</span>
            </li>
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-card p-6 sm:p-8 rounded-sm border border-border card-accent-left-gold text-left shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover"
            >
              <item.icon className="h-8 w-8 sm:h-9 sm:w-9 text-primary mb-4 sm:mb-5" />
              <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2">
                {item.title}
              </h3>
              <p className="text-text-body text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solution;
